export default "__VITE_ASSET__BA8Dv8M2__"